var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"08bb82d97df148a9e31d1739c773c9e902dedc4b"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      'https://8a4d089fa69047b98cf1a5914cb80932@o92833.ingest.sentry.io/6507288',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.05,
    ignoreErrors: [
      // Network errors from transient connectivity issues (all browser variants)
      /Failed to fetch/,
      /NetworkError when attempting to fetch resource/,
      /Network request failed/,
      /The Internet connection appears to be offline/,
      /The network connection was lost/,
      /A server with the specified hostname could not be found/,
      /Load failed/,
      // Chunk load errors from network issues during navigation
      /Loading chunk \d+ failed/,
      // Service worker registration failures (handled by useServiceWorker.js)
      /Failed to register a ServiceWorker/,
      // Safari Cache Storage disk write failure (low disk space, private browsing, iOS quota)
      /Failed writing data to the file system/,
      // Browser extension errors (password managers, ad blockers)
      /Object Not Found Matching Id/,
    ],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  })
}
